<template>
  <div class="content-panel">
    <div class="bcg-loading" v-if="loading">
      <v-progress-circular
        class="loading-spinner"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else>
      <handlers-wrapper-button :handlers="getHandlers()"/>
      <div class="statistics">
        <div class="stat-bar-filter">
          <hypoteky-filters-bar
            @period-filter-change="filterForPeriod($event)"
            @broker-filter-change="filterMortgages('financnik', $event)"
            @filter-client="filterMortgages('search', $event)"/>
          <hypoteky-stats/>
        </div>
      </div>
      <hypoteky-items-wrapper/>
    </div>
  </div>
</template>

<script>
import HypotekyStats from "../../../components/broker/KartaHypoteky/KartaHypotekyOverview/HypotekyStats";
import HypotekyItemsWrapper from "../../../components/broker/KartaHypoteky/KartaHypotekyOverview/HypotekyItemsWrapper";
import MortgageAddHandler from "../../../components/shared/PopupHandler/Popups/MortgageAdd/MortgageAddHandler";
import HypotekyFiltersBar from "../../../components/broker/KartaHypoteky/KartaHypotekyOverview/HypotekyFiltersBar";
import HandlersWrapperButton from "@/components/shared/PopupHandler/HandlerWrapper/HandlersWrapperButton.vue";

export default {
  name: "KartaHypoteky",
  components: {
    HandlersWrapperButton,
    HypotekyFiltersBar,
    HypotekyItemsWrapper,
    HypotekyStats,
  },
  methods: {
    getHandlers() {
      return [
        {
          component: "ObjectsRemoveHandler"
        },
        {
          component: "MortgageAddHandler",
          classCst: "button-item-handler white&#45;&#45;text no-decoration",
          button: true,
          rules: ['priority']
        },
      ]
    },
    filterForPeriod(period) {
      const ltFilter = {key: "created__lt", value: period.lt?.split(" ").join("")};
      this.$store.commit("mortgagesState/setMortgagesFilter", ltFilter);

      const gteFilter = {key: "created__gte", value: period.gte?.split(" ").join("")};
      this.$store.commit("mortgagesState/setMortgagesFilter", gteFilter);

      this.applyFilter();
    },
    filterMortgages(key, value) {
      this.$store.commit("mortgagesState/setMortgagesFilter", {key, value});
      this.applyFilter();
    },
    async applyFilter() {
      this.$store.commit("appState/setLoadingPage", true);
      await this.$store.dispatch("mortgagesState/fetchMortgages");
      this.$store.commit("appState/setLoadingPage", false);
    }
  },
  async created () {
    this.loading = true;
    this.role = this.$store.getters["userState/getRole"];
    if (this.role !== "alex_admin") {
      this.brokerId = this.$store.getters["userState/getId"];
      this.$store.commit("mortgagesState/setMortgagesFilter", {
        key: "financnik",
        value: this.brokerId,
      });
    }
    const pages =  {
      pozastavena: 1,
      zrusena: 1,
      vyber_riesenia: 1,
      podpis_ziadosti: 1,
      kompletizacia_podkladov: 1,
      schvalovanie: 1,
      servis: 1,
      cerpana: 1
    };
    this.$store.commit("mortgagesState/setStagePages", pages);
    await this.$store.dispatch("mortgagesState/initializeMortgages");
    this.loading = false;
    this.mortgagesInterval = setInterval(async () => {
      this.$store.dispatch("mortgagesState/fetchMortgages");
    }, 30000);
  },
  beforeDestroy () {
    // this.$store.commit("refreshMortgageDetailData");
    this.$store.commit("mortgagesState/resetMortgagesFilters");
    clearInterval(this.mortgagesInterval);
  },
  data: () => ({
    mortgagesInterval: null,
    loading: true,
    brokerId: null,
    role: null,
  }),
};
</script>

<style lang="scss" scoped>
.bcg-loading {
  z-index: 9999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
